import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
	Box,
	DurationOption,
	DurationToggle,
	DurationToggleContainer,
	HeadingStyled,
	MainHeading,
	SpanStyled,
	SubHeadingStyled,
	TextStyled,
} from '../../../ui/Elements';
import { PricingWrapper, PricingCardWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import { ButtonCustom, ContactButtonHref } from '../../../ui/CustomElements';
import { ChatPopup, Check, CheckBlue, Enterprise } from '../../../ui/AllImages';
import { pricingPlans } from "../../projectData/Data";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import LandingApi from "../../services/landingApi";
import { useNavigate } from "react-router-dom";

const enterprisePlanCheckList = [
	{ id: 1, listTxt: "feature_all_pro_features" },
	{ id: 2, listTxt: "feature_custom_workflows_automation" },
	{ id: 3, listTxt: "feature_dedicated_account_manager" },
	{ id: 4, listTxt: "feature_custom_integrations" },
	{ id: 5, listTxt: "feature_sla_support" },
];


const Pricing = () => {
	const {
		t,
		i18n: { language },
	} = useTranslation();

	const [show, setShow] = useState(false);
	const [plansList, setPlansList] = useState([]);
	const [selectedDuration, setSelectedDuration] = useState(1);

	const contactSales = () => setShow(true);

	const handlePlanClick = (id, price, duration) => {
		window.open(
			`https://myoffice.app4orce.com/signup?plan_id=${id}&amount=${price}&duration=${duration}`
		);
	};

	const getPlansList = async () => {
		try {
			const res = await LandingApi.getPlansList();
			if (res.code === 200 && res.data) {
				setPlansList(res.data);
			} else {
				setPlansList([]);
			}
		} catch (error) { }
	};

	useEffect(() => {
		getPlansList();
	}, [language]);


	return (
		<PricingWrapper className='container-fluid common-space pricingFluid' id="pricing">
			<Container>
				<Box className='benefitsRow row'>
					<Col md={12} className="benefitsColMain headingColMain">
						<Box className='benefitsDescCol1Content'>
							<MainHeading className='main-heading mb-3 servicesMH text-center'>
								{t('choosePlan')}
							</MainHeading>
							{/* <SpanStyled className='d-flex mb-4 transformTxt text-center' size="18px">
								{t('choosePlanDesc')}
							</SpanStyled> */}
						</Box>


					</Col>
					<DurationToggleContainer>
						<DurationToggle>
							<DurationOption
								active={selectedDuration === 1}
								onClick={() => setSelectedDuration(1)}
							>
								{t("monthly")}
							</DurationOption>
							<DurationOption
								active={selectedDuration === 12}
								onClick={() => setSelectedDuration(12)}
							>
								{t("annually")}
							</DurationOption>
						</DurationToggle>
					</DurationToggleContainer>
				</Box>

				<Box className="">
					<Swiper
						key={language}
						dir={language === "ar" ? "rtl" : "ltr"}
						rtl={language === "ar"}
						style={{ height: "100%" }}
						modules={[Pagination]}
						spaceBetween={30}
						slidesPerView={1}
						pagination={{ clickable: true }}
						breakpoints={{
							768: {
								slidesPerView: 2,
							},
							1200: {
								slidesPerView: 3,
							},
						}}
						>
						{plansList.map((plan) => {
							const title = language === "ar" ? plan.title_ar : plan.title_en;
							const description =
								language === "ar" ? plan.description_ar : plan.description_en;
							const features = plan.features ? plan.features.split(",") : [];

							const priceLabel =
								plan.prices && plan.prices[0]
									? plan.prices[0].price === "0.00"
										? t("price_0_sar")
										: `${plan.prices[0].price} ${t("sar")}`
									: t("price_not_available");
							const selectedPriceObj = plan?.prices?.find(
								(p) => parseInt(p?.duration) === parseInt(selectedDuration)
							);
							const price = selectedPriceObj
								? parseFloat(selectedPriceObj.price)
								: 0;

							const isFree = plan.prices && plan.prices[0]?.price === "0.00";

							let rawFeatures = [];
							if (selectedDuration === 1) {
								rawFeatures =
									language === "en"
										? plan?.monthly_features_en
											? plan?.monthly_features_en
											: []
										: plan?.monthly_features_ar
											? plan?.monthly_features_ar
											: [];
							} else if (selectedDuration === 12) {
								rawFeatures =
									language === "en"
										? plan?.annual_features_en
											? plan?.annual_features_en
											: []
										: plan?.annual_features_ar
											? plan?.annual_features_ar
											: [];
							}

							return (
								<SwiperSlide key={plan.id}>
									<PricingCardWrapper 
										className="p-4 p-md-3 custom-p-lg-4 my-2 priceBox" 
										color="var(--themeColor)"
										border="var(--borderExtraLight)"
										isBorder={true}
										>
										<MainHeading
											weight="bold"
											size="24px"
											color="var(--textDark)"
											className="plan-heading"
										>
											{title}
										</MainHeading>
										<TextStyled
											size="16px"
											weight="400"
											color="var(--text2)"
											className="plan-desc"
										>
											{description}
										</TextStyled>

										<Box className="mt-3 mb-3">
											<MainHeading
												size="30px"
												weight="bold"
												color="var(--themeColor)"
											>
												{/* {isFree ? t("free") : `${price} ${t("sar")}`} */}
												{isFree ? (
													t("free")
												) : (
													<>
														{price} <span className="priceSAR">{t("sar")}</span>
													</>
												)}
											{/* <SubHeadingStyled
												size="28px"
												weight="bold"
												color="var(--themeColor)"
											>
												{isFree ? t("free") : `${price} ${t("sar")}`} */}

											</MainHeading>
											<TextStyled color="var(--text)" size="14px">
												{isFree
													? plan?.prices[0]?.duration_label
													: selectedDuration === 1
														? t("monthly")
														: t("annually")}
											</TextStyled>
										</Box>

										<ButtonCustom
											label={t("get_started")}
											bg="var(--white)"
											border="1px solid var(--themeColor)"
											color="var(--themeColor)"
											className="w-100 justify-content-center"
											clName="w-100"
											onClick={() =>
												handlePlanClick(
													plan?.id,
													plan?.prices[0]?.price,
													selectedDuration
												)
											}
										/>

										<Box className="mt-4">
											{rawFeatures.length > 0 &&
												rawFeatures.map((ftr, i) => (
													<Box key={i} className="d-flex mb-4">
														<Box>
															<CheckBlue />
														</Box>
														<SpanStyled
															size="16px"
															color="var(--textDark)"
															className="mx-3"
														>
															{ftr.trim()}
														</SpanStyled>
													</Box>
												))}
										</Box>
									</PricingCardWrapper>
								</SwiperSlide>
							);
						})}
					</Swiper>

						{/* <Row className="justify-content-center priceWrapper">
							{pricingPlans.map((plan, key) => (
								<Col lg={4} md={12}>
									<PricingCardWrapper
										className={`custom-p-lg-4 priceBox`}
										color={plan.stroke}
										border={plan.border}
										isBorder={plan.isBorder}
										>
										<MainHeading
											weight="bold"
											size="24px"
											color="var(--textDark)"
											className="plan-heading"
										>
											{t(plan.plan_name)}
										</MainHeading>
										
										{plan.isCustom ? (
											<>
												<Box className="mb-3 pt-2">
													<Box className="priceIcoCus">
														<Enterprise />
													</Box>
													<SpanStyled color="var(--textDark)" size="14px">
														{t("contact_sales_for_pricing")}
													</SpanStyled>
												</Box>
											</>
										) : (
											<Box className="mt-3 mb-3">
												<MainHeading
													size="30px"
													weight="bold"
													color="var(--themeColor)"
												>
													{plan.price} <span className="priceSAR">{t("sar")}</span>
												</MainHeading>
												<SpanStyled color="var(--textDark)" size="14px">
													{plan.isBasic
														? t("free_forever")
														: plan.isCustom
															? t("contact_sales_for_pricing")
															: t("per_user_month")}
												</SpanStyled>
											</Box>
										)}
										<ButtonCustom
											label={t(plan.btn_text)}
											bg={`var(${plan.bg})`}
											border={plan.border}
											color={plan.color}
											className="w-100 justify-content-center"
											clName="w-100"
											// {...(plan.isCustom
											// ? { onClick: handleShow }
											// : { onClick: () => handlePlanClick(plan) })}
										/>
										
										<Box className="mt-4">
											{plan.access_features.map((ftr, i) => (
												<Box className="d-flex mb-4">
													<Box>
														<CheckBlue />
													</Box>
													<SpanStyled
														size="16px"
														color="var(--textDark)"
														className="mx-3"
													>
														{t(ftr)}
													</SpanStyled>
												</Box>
											))}
										</Box>
									</PricingCardWrapper>
								</Col>
							))}
						</Row> */}
						
				</Box>
			</Container>

		</PricingWrapper>
	);
};

export default Pricing;
